const BOT_TIME_ZONES = new Set(['UTC', 'Etc/UTC', 'Etc/Unknown']);

/**
 * 시간대가 UTC 면 봇으로 본다. 실사용자 폰은 거의 지역 시간대를 쓰고(KR 25.8만 중 UTC 17명),
 * UTC 집단은 데이터센터 IP 에서 실사용자가 연 URL 을 며칠 뒤 다시 여는 봇이었다.
 */
export const isLikelyBotTimeZone = (timeZone: string): boolean =>
  BOT_TIME_ZONES.has(timeZone);

export interface BotSignal {
  zep_time_zone: string;
  zep_likely_bot: boolean;
}

/** 브라우저에서만 판정한다 — 서버 런타임 시간대는 사용자와 무관하게 대개 UTC 다. */
export const collectBotSignal = (): BotSignal | null => {
  if (typeof window === 'undefined') return null;
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
    return {
      zep_time_zone: timeZone,
      zep_likely_bot: isLikelyBotTimeZone(timeZone),
    };
  } catch {
    return null;
  }
};
